
import { PunkParsedGameData } from "../../../server/data/PunkParsedGameData";
import { PosterManager } from "../../independent/Poster/PosterManager";
import { SoundManager } from "../../../resource/sound/SoundManager";
import { SoundConfig } from "../../../SoundConfig";
import { ArrayHelper } from "@nolimitcity/slot-game/bin/core/utils/ArrayHelper";
import { ReelAnimationManager } from "../../independent/reelAnimator/ReelAnimationManager";
import { Presentation, PresentationState } from "@nolimitcity/slot-game/bin/core/gamecontroller/presentations/Presentation";
import { GameMode } from "@nolimitcity/slot-game/bin/core/gamemode/GameMode";
import { PunkEngineManager } from "../../../punkEngine/PunkEngineManager";

export class ReelStoppedPresentation extends Presentation {

    protected totalWinAmount:number = 0;
    protected _lockedReelPositions:boolean[];

    protected respinUnChain:boolean = false;
    protected delayPreFeature:boolean = false;

    protected normal:boolean = false;
    protected expandCheck:boolean = false;

    protected winReelLengt:number  = 0;

    public setParsedGamedData(data:PunkParsedGameData):void{

        this.winReelLengt = data.allWinData.longest;

        this.normal = data.mode == GameMode.NORMAL;
        const nextIsFeature:boolean = data.nextMode != GameMode.NORMAL;

        this.expandCheck = data.mysteryData != null && !!data.mysteryData!.mysterySymbolAppeared;

        this.respinUnChain = data.mode == GameMode.RESPIN;
        this.delayPreFeature = data.singleWin == 0 && this.normal && nextIsFeature;

        this.totalWinAmount = data.totalWin;
        this._lockedReelPositions = ArrayHelper.initArrayWithValues(PunkEngineManager.AllReels.length, () => false);
        PunkEngineManager.AllReels.forEach(reel => { if(!reel.isActive) this._lockedReelPositions[reel.reelID] = true;});
    }

    public checkForActivation(data:PunkParsedGameData):boolean{ return true };

    public getPresentation(){
        this.PresentationState.set(PresentationState.INACTIVE);

        if(this.delayPreFeature) this.pTimeline.to(this,0.2,{});

        if(this.respinUnChain){
            PosterManager.instance.playSirene(false);
            SoundManager.playSoundEffect( SoundConfig.instance.CHAIN2)
            for(let reel:number = 0; reel < this._lockedReelPositions.length;reel++)
                if(this._lockedReelPositions[reel]) this.pTimeline.add(ReelAnimationManager.getReelArea(reel).chainsActive(false),0)
        }
    }
}